import FiguresTooltip from '../FiguresTooltip';
import { Tooltip } from 'antd';

const NKT = props => {
    const { research, scale, minDepth, title, date, width, toDepth } = props;

    const bottom = toDepth(research.bottom);

    return (
        <Tooltip
            title={<FiguresTooltip title={title} bottom={bottom} date={date} />}
            styles={{ root: { maxWidth: 'none' } }}
        >
            <svg
                width={width}
                height="60"
                viewBox="0 0 79 60"
                fill="none"
                style={{
                    position: 'absolute',
                    transform: `translateY(${Math.abs((minDepth - bottom + 2) * scale)}px)`,
                }}
            >
                <defs>
                    <clipPath id="clip0_457_19673">
                        <rect id="svg_1" x="46" y="52" fill="white" height="8" width="8" />
                    </clipPath>
                    <clipPath id="clip1_457_19673">
                        <rect id="svg_2" x="36" y="52" fill="white" height="8" width="8" />
                    </clipPath>
                </defs>
                <g>
                    <g id="svg_3" clipPath="url(#clip0_457_19673)">
                        <line
                            id="svg_4"
                            strokeLinejoin="bevel"
                            strokeLinecap="square"
                            stroke="#7E8DA9"
                            y2="59.5"
                            x2="51"
                            y1="59.5"
                            x1="49"
                        />
                        <line id="svg_5" strokeLinecap="round" stroke="#7E8DA9" y2="52.5" x2="50" y1="59.5" x1="50" />
                        <path id="svg_6" stroke="#7E8DA9" d="m53,53.5l0,-1l-6,0l0,1" />
                    </g>
                    <g id="svg_7" clipPath="url(#clip1_457_19673)">
                        <path
                            id="svg_8"
                            fill="#7E8DA9"
                            d="m39.0932,55.7095c-0.1605,0.2247 -0.1084,0.537 0.1163,0.6975c0.2247,0.1605 0.537,0.1084 0.6975,-0.1163l-0.8138,-0.5812zm2.9068,-3.2095l0,-0.5l-0.2573,0l-0.1496,0.2094l0.4069,0.2906zm-2.093,3.7907l2.4999,-3.5001l-0.8138,-0.5812l-2.4999,3.5001l0.8138,0.5812zm2.093,-3.2907l1.5,0l0,-1l-1.5,0l0,1z"
                        />
                        <path
                            id="svg_9"
                            fill="#7E8DA9"
                            d="m39.1336,56.3402c-0.1879,-0.2023 -0.1762,-0.5187 0.0262,-0.7066c0.2023,-0.1879 0.5187,-0.1762 0.7066,0.0262l-0.7328,0.6804zm3.6164,3.1598l0,0.5l-0.218,0l-0.1484,-0.1598l0.3664,-0.3402zm-2.8836,-3.8402l3.25,3.5l-0.7328,0.6804l-3.25,-3.5l0.7328,-0.6804zm2.8836,3.3402l1.25,0l0,1l-1.25,0l0,-1z"
                        />
                        <path id="svg_10" strokeLinecap="round" stroke="#7E8DA9" d="m38.5,56l1,0" />
                        <line id="svg_11" strokeLinecap="round" stroke="#7E8DA9" y2="52.5" x2="38" y1="59.5" x1="38" />
                        <path id="svg_12" stroke="#7E8DA9" d="m37,52.5l2,0" />
                        <path id="svg_13" stroke="#7E8DA9" d="m37,59.5l2,0" />
                    </g>
                    <line id="svg_14" strokeLinecap="round" stroke="#7E8DA9" y2="52.5" x2="32.5" y1="59.5" x1="32.5" />
                    <path id="svg_15" stroke="#7E8DA9" d="m31.5,59.5l2,0" />
                    <path id="svg_16" stroke="#7E8DA9" d="m31.5,52.5l2,0" />
                    <path id="svg_17" strokeLinecap="round" stroke="#7E8DA9" d="m28,56l4,0" />
                    <path id="svg_18" stroke="#7E8DA9" d="m26.5,52.5l2,0" />
                    <path id="svg_19" stroke="#7E8DA9" d="m26.5,59.5l2,0" />
                    <line id="svg_20" strokeLinecap="round" stroke="#7E8DA9" y2="52.5" x2="27.5" y1="59.5" x1="27.5" />
                    <path
                        id="svg_21"
                        stroke="#7E8DA9"
                        d="m59.25,0l0,27.8334c0,0.2652 0.1053,0.5196 0.2929,0.7071l17.7502,17.7524c0.6299,0.63 0.1838,1.7071 -0.7071,1.7071l-74.17199,0c-0.89088,0 -1.33706,-1.0771 -0.70715,-1.7071l17.75024,-17.7524c0.1876,-0.1875 0.2929,-0.4419 0.2929,-0.7071l0,-27.8334"
                    />
                </g>
            </svg>
        </Tooltip>
    );
};

export default NKT;
